import request from '../utils/request'

export const apiLogin = data => request({ url: '/api/login', method: 'post', data })
export const apiCategoryList = () => request({ url: '/api/category/list', method: 'get' })
export const apiBrandList = () => request({ url: '/api/brand/list', method: 'get' })
export const apiBannerList = () => request({ url: '/api/banner/list', method: 'get' })
export const apiProductPage = params => request({ url: '/api/product/page', method: 'get', params })
export const apiProductRecommend = params => request({ url: '/api/product/recommend', method: 'get', params })
export const apiProductDetail = (id, token) =>
  request({ url: '/api/product/' + id, method: 'get', params: { token } })
export const apiCollectAdd = data => request({ url: '/api/collect/add', method: 'post', data })
export const apiCollectCancel = data => request({ url: '/api/collect/cancel', method: 'post', data })
export const apiCollectList = params => request({ url: '/api/collect/list', method: 'get', params })
export const apiCollectCheck = params => request({ url: '/api/collect/check', method: 'get', params })

export const apiHomeCoverActive = () => request({ url: '/api/home-cover/active', method: 'get' })
